import { render, staticRenderFns } from "./GoalOverview.vue?vue&type=template&id=7ec8ac9d&"
import script from "./GoalOverview.vue?vue&type=script&lang=js&"
export * from "./GoalOverview.vue?vue&type=script&lang=js&"
import style0 from "./GoalOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports